import React from 'react'
import { useCmsPageByPath } from 'lib/core/hooks'
import { MetaData } from 'lib/shared'
import { FadeIn } from 'lib/ui'
import { Container } from './styled'

export const CmsPage = () => {
  const { content_heading: contentHeading, content } = useCmsPageByPath()

  return (
    <>
      <MetaData
        type='CMS'
      />
      <Container>
        <FadeIn>
          <h1>
            {contentHeading}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: content
            }}
          />
        </FadeIn>
      </Container>
    </>
  )
}
